import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Dashboard from '@/features/dashboard'

export const Route = createFileRoute('/_authenticated/')({
  component: Dashboard,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Tableau de bord`,
      },
    ],
  }),
})
